import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProAccountsState, ProAccountAnalytics, ProAccountList } from "./types";
import { fetchProAccountAnalytics, fetchProAccountList } from "./actions";

const initialState: ProAccountsState = {
  analytics: null,
  loading: "idle",
  error: null,
  proAccountList: null,
  proAccountListLoading: "idle",
  proAccountListError: null,
};

const proAccountsSlice = createSlice({
  name: "proAccounts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProAccountAnalytics.pending, (state) => {
        state.loading = "pending";
        state.error = null;
      })
      .addCase(
        fetchProAccountAnalytics.fulfilled,
        (state, action: PayloadAction<ProAccountAnalytics>) => {
          state.loading = "succeeded";
          state.analytics = action.payload;
        }
      )
      .addCase(fetchProAccountAnalytics.rejected, (state, action: PayloadAction<any>) => {
        state.loading = "failed";
        state.error = action.payload?.message || "Failed to fetch pro accounts analytics data";
      })

      .addCase(fetchProAccountList.pending, (state) => {
        state.proAccountListLoading = "pending";
        state.proAccountListError = null;
      })
      .addCase(
        fetchProAccountList.fulfilled,
        (state, action: PayloadAction<ProAccountList>) => {
          state.proAccountListLoading = "succeeded";
          state.proAccountList = action.payload;
        }
      )
      .addCase(fetchProAccountList.rejected, (state, action: PayloadAction<any>) => {
        state.proAccountListLoading = "failed";
        state.proAccountListError = action.payload?.message || "Failed to fetch pro accounts list";
      });
  },
});

export default proAccountsSlice.reducer;
